import axios from 'axios'
import { EVENT, EVENTS_FOR_SUPPLIER, EVENT_PAYOFF, USER_TOKEN } from "./CONSTANTS";

export const getEvents = (status) => {
  console.info("eventServices > getEvents...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT()+(status?"?status="+status:""),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
export const getEventsForSupplier = () => {
  console.info("eventServices > getEventsForSupplier...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENTS_FOR_SUPPLIER(),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getEvent = (uniqueKey) => {
  console.info("eventServices > getEvents...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT()+"/"+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};


export const addEvent = (model) => {
  console.info("eventServices > addEvent...");
  return new Promise((resolve, reject) => {
      axios
      .post(EVENT(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const updateEvent = (model) => {
  console.info("updateServices > updateEvent...");
  return new Promise((resolve, reject) => {
      axios
      .put(EVENT(), model,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const deleteEvent = (uniqueKey) => {
  console.info("eventServices > deleteEvent...");
  return new Promise((resolve, reject) => {
      axios
      .delete(EVENT()+'/'+uniqueKey,{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        }
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};

export const getEventPayOff = (uniqueKey, format) => {
  console.info("eventServices > getEventPayOff...");
  return new Promise((resolve, reject) => {
      axios
      .get(EVENT_PAYOFF()+"?uniqueKey="+uniqueKey+(format?"&format="+format:""),{
        headers: {
          'Authorization': `Bearer ${USER_TOKEN()}`
        },
        responseType: format && format =='excel' ?'blob':'json'
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};